/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Personal_Strength_Open_ProfileInputs */

const en_us2_exercise_personal_strength_open_profile = /** @type {(inputs: Exercise_Personal_Strength_Open_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open profile`)
};

const pt_br2_exercise_personal_strength_open_profile = /** @type {(inputs: Exercise_Personal_Strength_Open_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir perfil`)
};

const es_419_exercise_personal_strength_open_profile = /** @type {(inputs: Exercise_Personal_Strength_Open_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir perfil`)
};

const pt_pt2_exercise_personal_strength_open_profile = /** @type {(inputs: Exercise_Personal_Strength_Open_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir perfil`)
};

const fr_fr2_exercise_personal_strength_open_profile = /** @type {(inputs: Exercise_Personal_Strength_Open_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouvrir le profil`)
};

const de_de2_exercise_personal_strength_open_profile = /** @type {(inputs: Exercise_Personal_Strength_Open_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil öffnen`)
};

const it_it2_exercise_personal_strength_open_profile = /** @type {(inputs: Exercise_Personal_Strength_Open_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apri profilo`)
};

/**
* | output |
* | --- |
* | "Open profile" |
*
* @param {Exercise_Personal_Strength_Open_ProfileInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_personal_strength_open_profile = /** @type {((inputs?: Exercise_Personal_Strength_Open_ProfileInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Personal_Strength_Open_ProfileInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_personal_strength_open_profile(inputs)
	if (locale === "es-419") return es_419_exercise_personal_strength_open_profile(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_personal_strength_open_profile(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_personal_strength_open_profile(inputs)
	if (locale === "de-DE") return de_de2_exercise_personal_strength_open_profile(inputs)
	if (locale === "it-IT") return it_it2_exercise_personal_strength_open_profile(inputs)
	return en_us2_exercise_personal_strength_open_profile(inputs)
});
export { exercise_personal_strength_open_profile as "exercise-personal.strength_open_profile" }